import { CloseFill30Icon } from "@vygruppen/spor-icon-react";
import { EventChangesComparison } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/EventChangesComparison";
import { EventChangesHeader } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/EventChangesHeader";
import {
  PlanEventInformation,
  PlanInternalMessage,
} from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import { markEventAsSeen } from "features/CenterContent/RoleContent/EventHandling/utils";
import { useEventHandlingContext } from "features/CenterContent/RoleContent/EventHandling/EventHandlingContext";
import {
  eventIsInfrastructureEvent,
  eventIsTrainEvent,
} from "features/History/utils/utils";
import { FC } from "react";
import {
  DialogActionTrigger,
  DialogFooter,
  DialogRoot,
  DropsButton,
  DropsDialogContent,
  IconButton,
} from "shared/components/Spor";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { Nullish } from "shared/utils/objectUtils";
import { useTheme } from "styled-components";

export type EventChangesDialogProps = {
  open: boolean;
  setopen: (open: boolean) => void;
  event: CombinedHistoryResponse;
  eventInternalMessages: PlanInternalMessage[];
  previousEvent: Nullish<PlanEventInformation>;
  onConfirmed?: () => void;
};

function getTitle(event: CombinedHistoryResponse): string {
  if (eventIsInfrastructureEvent(event)) {
    return event.stretchName;
  }

  if (eventIsTrainEvent(event)) {
    return event.trainIdentifier.identifier;
  }

  return event.type.label ?? "Ukjent hendelse";
}

const EventChangesDialog: FC<EventChangesDialogProps> = ({
  open,
  setopen,
  event,
  eventInternalMessages,
  previousEvent,
  onConfirmed,
}) => {
  const theme = useTheme();
  const { notifySeenChanged } = useEventHandlingContext();

  const title = getTitle(event);

  if (!previousEvent) return;

  return (
    <DialogRoot open={open} size="sm" onOpenChange={() => setopen(false)}>
      <DropsDialogContent
        overflowY="scroll"
        backgroundColor={theme.colorBackgroundMain}
        position="relative"
      >
        <EventChangesHeader title={title} updatedAt={event.updatedAt} />

        <IconButton
          onClick={() => setopen(false)}
          icon={<CloseFill30Icon />}
          variant="ghost"
          position="absolute"
          top="3"
          right="3"
        />

        <EventChangesComparison
          previousEvent={previousEvent}
          latestEvent={event}
          latestEventInternalMessages={eventInternalMessages}
        />

        <DialogFooter p="4" pt="3">
          <DialogActionTrigger asChild>
            <DropsButton
              variant="ghost"
              size="md"
              onClick={() => setopen(false)}
              ml="0px"
              mr="auto"
              fontWeight="700"
            >
              Avbryt
            </DropsButton>
          </DialogActionTrigger>
          <DialogActionTrigger asChild>
            <DropsButton
              size="md"
              onClick={() => {
                markEventAsSeen(event.uuid, event.version);
                notifySeenChanged();
                setopen(false);
                onConfirmed?.();
              }}
              ml="auto"
              mr="0px"
            >
              Bekreft sett
            </DropsButton>
          </DialogActionTrigger>
        </DialogFooter>
      </DropsDialogContent>
    </DialogRoot>
  );
};

export default EventChangesDialog;
